(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-common-wager/assets/javascripts/collections/wagers.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-common-wager/assets/javascripts/collections/wagers.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.numbergames.mybets_common_wager.collections.Wagers = svs.numbergames.core.NumbergamesCollection.extend({
  model: svs.numbergames.mybets_common_wager.models.Wager,
  modelId(attrs) {
    return attrs.wagerId;
  },
  initialize() {
    svs.numbergames.mybets_common_wager.logger.debug('collections.Wagers initialize', this.models);
  },
  parse(models, options) {
    svs.numbergames.mybets_common_wager.logger.debug('collections.Wagers parse', models, options);
    if (models && options.isActiveWagers) {
      models = svs.numbergames.mybets_core_wager.parsers.parseActiveWagers(models, options);
    }
    return models;
  },
  updateWager(wagerId) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    svs.numbergames.mybets_common_wager.logger.debug('collections.Wagers updateWager', wagerId);
    const success = model => {
      this.trigger('wager:fetched', model);
      if (options.success) {
        const context = options.context || this;
        options.success.call(context, model);
      }
    };
    const model = this.get(wagerId);
    if (!model) {
      this.create({
        wagerId
      }, _objectSpread(_objectSpread({}, options), {}, {
        wait: true,
        idAttribute: 'wagerId',
        success,
        context: this
      }));
    } else if (model.isNew()) {
      model.fetch({
        idAttribute: 'wagerId',
        success,
        context: this
      });
    } else {
      success(model);
    }
  }
});

 })(window);